import React from "react";
import Navbar from "./components/Navbar";
import "./App.css";
import Home from "./components/pages/Home";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import France from "./components/pages/France";
import Spain from "./components/pages/Spain";
import Italy from "./components/pages/Italy";
import Tickets from "./components/pages/Tickets";
import Video from "./components/pages/video.js";

function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Switch>
          <Route path="/france" component={France} />
          <Route path="/spain" component={Spain} />
          <Route path="/itlay" component={Italy} />
          <Route path="/tickets" component={Tickets} />
          <Route path="/video" component={Video} />
          <Route Path="/" exact component={Home} />
        </Switch>
      </Router>
    </>
  );
}

export default App;
